module.exports = __webpack_public_path__ + "media/images/countrysquared/gq-e50d3f05c6fa559465abd0c6ed9dd7f4.svg";